// extracted by mini-css-extract-plugin
export default {"flexContainer":"Ratings-module__flexContainer___AOcD6","ctaText":"Ratings-module__ctaText___3CFOO","circle":"Ratings-module__circle___22WFA"};